<section class="wrapper {{label.toLowerCase().split(' ').join('_')}}" (click)="expandedChart = !expandedChart && isMiniChartAvailable" [class.mini-chart-hidden]="!isMiniChartAvailable" [class.out-of-range-wrapper]="isOutOfRange && showRowHighlight" [class.row-highlight]="showRowHighlight">
    <div class="summary-line" *ngIf="!onlyExpanded">
       <div class="summary-label" genTooltip [tooltipShow]="tooltipShow" [tooltipHtml]="tooltipText" [appendToBody]="true" [tooltipPosition]="tooltipPosition">
           <span class="main-label">{{label}}</span>
           <span *ngIf="showUnitsWarning"
                 class="icon-container icon-container-warning"
                 genTooltip
                 tooltipText="NOT_ALL_MEASURES_ARE_IN_THE_SAME_UNIT"
                 tooltipShow="true"
                 tooltipPosition="BOTTOM">!</span>
        <span class="sub-label">{{subLabel}}</span>
       </div>
        <div class="mini-chart" *ngIf="isMiniChartAvailable" [ngSwitch]="chartType">
            <gen-generic-line-chart
                    *ngSwitchCase="'line'"
                    [data]="meassurements"
                    [current]="hideCurrentItemAnnotation ? null : date"
                    [hideLinePoints]="hideMiniLinePoints"
                    [mini]="true"
            ></gen-generic-line-chart>
        </div>

        <div class="data-container">
            <br>
            <span class="indicator">{{indicator}}</span>
            <span class="value" [class.out-of-range]="isOutOfRange">{{value}}</span><br />
            <span class="unit">{{unit}}</span>

        </div>
    </div>
    <div class="summary-line-expanded" *ngIf="onlyExpanded">
       <span class="summary-label" genTooltip [tooltipShow]="tooltipShow" [tooltipHtml]="tooltipText" [appendToBody]="true" [tooltipPosition]="tooltipPosition">
           <span *ngIf="label">{{label}}</span><span *ngIf="unit"> ({{unit}})</span>
           <span *ngIf="showUnitsWarning"
                 class="icon-container icon-container-warning"
                 genTooltip
                 tooltipText="NOT_ALL_MEASURES_ARE_IN_THE_SAME_UNIT"
                 tooltipShow="true"
                 tooltipPosition="BOTTOM">!</span>
        <span class="indicator">{{indicator}}</span>
       </span>
    </div>
    <div class="chart-container-wrapper" [class.expanded]="expandedChart || onlyExpanded">
        <div class="chart-container" [ngSwitch]="chartType">
            <gen-generic-line-chart
                    *ngSwitchCase="'line'"
                    [data]="meassurements"
                    [current]="hideCurrentItemAnnotation ? null : date"
                    [hideLinePoints]="hideLinePoints"
            ></gen-generic-line-chart>
        </div>
    </div>
</section>
